export default __webpack_public_path__ + "static/media/dm.8d613ebe.svg";